import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Button, ButtonToolbar, Input, Modal } from "reactstrap";
import classNames from "classnames";
import { RTLProps } from "../prop-types/ReducerProps";

const ModalComponent = ({
  color,
  title,
  message,
  colored,
  header,
  rtl,
  modal,
  toggle,
  onOk,
  onCancel,
  showCancel,
  showInput,
  inputValue,
  onInputChange,
}) => {
  let Icon;

  switch (color) {
    case "primary":
      Icon = <span className="lnr lnr-pushpin modal__title-icon" />;
      break;
    case "success":
      Icon = <span className="lnr lnr-thumbs-up modal__title-icon" />;
      break;
    case "warning":
      Icon = <span className="lnr lnr-flag modal__title-icon" />;
      break;
    case "danger":
      Icon = <span className="lnr lnr-cross-circle modal__title-icon" />;
      break;
    default:
      break;
  }
  const modalClass = classNames({
    "modal-dialog--colored": colored,
    "modal-dialog--header": header,
  });

  return (
    <Modal
      isOpen={modal}
      toggle={toggle}
      modalClassName={`${rtl.direction}-support`}
      className={`modal-dialog--${color} ${modalClass}`}
    >
      <div className="modal__header">
        <button
          className="lnr lnr-cross modal__close-btn"
          type="button"
          onClick={toggle}
        />
        {header ? "" : Icon}
        <h4 className="text-modal  modal__title">{title}</h4>
      </div>
      <div className="modal__body">
        {message}

        {showInput && (
          <div className="mt-3">
            <Input
              type="textarea"
              placeholder="Ingrese aquí el motivo del rechazo..."
              rows="4"
              value={inputValue}
              onChange={onInputChange}
            />
          </div>
        )}
      </div>

      <ButtonToolbar className="modal__footer">
        {showCancel && (
          <Button color="secondary" onClick={onCancel}>
            {showInput ? "Cancelar" : "No"}   
          </Button>
        )}
        <Button
          color={color}
          onClick={onOk}
          disabled={showInput && !inputValue.trim()}
        >
          {showInput ? "GUARDAR" : "Sí"}
        </Button>
      </ButtonToolbar>
    </Modal>
  );
};

ModalComponent.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  color: PropTypes.string.isRequired,
  colored: PropTypes.bool,
  header: PropTypes.bool,
  rtl: RTLProps.isRequired,
};

ModalComponent.defaultProps = {
  title: "",
  message: "",
  colored: false,
  header: false,
};

export default connect((state) => ({
  rtl: state.rtl,
}))(ModalComponent);
